module.exports = "/images/request_driver_regis_white.svg?df4acfc968086050ee660d4725b86142";